import React from 'react';
import { AlertCircle } from 'lucide-react';

export const WarningMessage = () => {
  return (
    <div className="flex items-start gap-3 bg-yellow-50 text-yellow-700 p-4 rounded-lg">
      <AlertCircle className="shrink-0 mt-0.5" size={20} />
      <div className="text-sm">
        <p className="font-medium">تنبيه مهم</p>
        <p>تأكد من أن الملف يتبع النموذج المطلوب. يجب أن يحتوي على الأعمدة التالية:</p>
        <ul className="mt-2 list-disc list-inside">
          <li>رقم الخيمة</li>
          <li>رقم الصالة</li>
          <li>عدد الاسرة</li>
          <li>نوع الاسرة (male/female)</li>
        </ul>
      </div>
    </div>
  );
};